import { lazyLoad } from "../../../../utils/loadable.js";

export const LinksCreator = lazyLoad(
    () => import("./index.js"),
    (module) => module.LinksCreator,
);
